import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { useFilters, useOverrides } from '../../store';
import type { Flag } from '../../types';
import css from './stats.module.scss';
interface Props {
  flags: Flag[];
}
export function Stats(t0) {
  const $ = _c(22);
  const {
    flags
  } = t0;
  const intl = new Intl.NumberFormat("en-US", {
    minimumIntegerDigits: 2
  });
  const {
    overrides,
    filter,
    toggleFilter
  } = useOverrides();
  const {
    category
  } = useFilters();
  let t1;
  if ($[0] !== category) {
    t1 = f => category === "all" || f.category === category;
    $[0] = category;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const total = flags.filter(t1);
  const t2 = !filter;
  let t3;
  if ($[2] !== t2) {
    t3 = cn(css.group, {
      [css.active]: t2
    });
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== toggleFilter) {
    t4 = () => toggleFilter(false);
    $[4] = toggleFilter;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p>Total</p>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== filter) {
    t6 = cn(css.group, {
      [css.active]: filter
    });
    $[7] = filter;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== toggleFilter) {
    t7 = () => toggleFilter(true);
    $[9] = toggleFilter;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p>Overrides</p>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = css;
  let t10;
  if ($[12] !== overrides) {
    t10 = f_0 => f_0.key in overrides;
    $[12] = overrides;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = total.filter(t10);
  let t12;
  if ($[14] !== t11.length || $[15] !== t9.overrides) {
    t12 = <span className={t9.overrides}>{t11.length}</span>;
    $[14] = t11.length;
    $[15] = t9.overrides;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
    t13 = <button className={t6} onClick={t7}>{t8}{t12}</button>;
    $[17] = t12;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  return <div className={css.row}><button className={t3} onClick={t4}>{t5}<span className={css.total}>{intl.format(total.length)}</span></button>{t13}</div>;
}